// extracted by mini-css-extract-plugin
export default {"success":"feedbackComponent_success__B9g7u","error":"feedbackComponent_error__1r+hv"};